import Headroom from 'headroom.js'
import LazyLoad from 'vanilla-lazyload'

/**
 * GlobalHeader functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalHeader {
  /**
   * Constructs a new GlobalHeader instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.navToggle = this.element.querySelector('[data-component="nav-toggle"]')
    this.mainNav = this.element.querySelector('[data-component="main-nav"]')
    this.navItems = this.mainNav.queryAll('nav ul li a')
    this.navigationImages = this.element.querySelector('[data-component="navigation-images"]')
    this.navigationImagesLists = this.navigationImages.queryAll('ul')
    this.touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)

    this.navToggle.addEventListener('click', e => {
      this.element.classList.toggle('nav-open')
      this.navToggle.classList.toggle('is-active')
      document.body.classList.toggle('locked')
    })

    if (!this.touchDevice) {
      this.navItems.forEach(navItem => {
        navItem.addEventListener('mouseenter', e => {
          var index = this.navItems.indexOf(navItem)
          this.mainNav.classList.add('light-bg')
          this.activate(navItem, index)
        })
        navItem.addEventListener('mouseleave', e => {
          var index = this.navItems.indexOf(navItem)
          this.mainNav.classList.remove('light-bg')
          this.reset(navItem, index)
        })
      })
    }

    let headroom = new Headroom(this.element, {
      "tolerance": 0
    })

    headroom.init()

  }

  reset (navItem, index) {
    if (this.navigationImagesLists) {
      this.navigationImagesLists[index].classList.remove('visible')
    }
  }

  activate (navItem, index) {
    if (this.navigationImagesLists) {
      this.navigationImagesLists[index].classList.add('visible')
    }
  }

}



// WEBPACK FOOTER //
// ./components/global-header/index.js